import { useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./useAuth";
import { useProfile } from "./useAuth";

export type AuditActionType =
  | "login"
  | "logout"
  | "create_dossier"
  | "delete_dossier"
  | "update_dossier"
  | "change_status_dossier"
  | "import_balance"
  | "import_efi"
  | "update_mapping"
  | "update_pointage"
  | "export_dossier"
  | "invite_user"
  | "accept_invitation"
  | "revoke_invitation"
  | "create_licence"
  | "update_licence"
  | "register_device"
  | "revoke_device"
  | "update_profile"
  | "update_organization"
  | "archive_dossier";

interface LogOptions {
  action_type: AuditActionType;
  resource_type?: string;
  resource_id?: string;
  details?: Record<string, unknown>;
}

export function useAuditLog() {
  const { user } = useAuth();
  const { profile } = useProfile();

  const log = useCallback(
    async ({ action_type, resource_type, resource_id, details }: LogOptions) => {
      if (!user) return;

      try {
        await supabase.from("audit_logs").insert({
          user_id: user.id,
          user_email: user.email ?? null,
          organization_id: profile?.organization_id ?? null,
          action_type,
          resource_type: resource_type ?? null,
          resource_id: resource_id ?? null,
          details: (details ?? {}) as never,
        });
      } catch (err) {
        // Audit logging should never break the UI
        console.warn("[audit] Failed to log action:", action_type, err);
      }
    },
    [user, profile?.organization_id]
  );

  return { log };
}
